import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticatedUserService } from '../shared/services/authenticated-user.service';
import { User } from '../shared/models/user';
import { RoleEnum } from '../shared/enums/role.enum';
import { Observable, filter, map, of, switchMap, take } from 'rxjs';
import { CompanyPagesService } from './services/company-pages.service';
import { UserCompanyDetails } from 'src/app/shared/models/user-company-details';

@Injectable()
export class CompanyPagesPermissionsService {
  private authenticatedUserService = inject(AuthenticatedUserService);
  private companyPagesService = inject(CompanyPagesService);
  private router = inject(Router);

  canActivate(): Observable<boolean> {
    return this.authenticatedUserService.getUserSubject().pipe(
      filter((user): user is User => user !== null),
      take(1),
      switchMap(user => {
        if (!user.roleList.includes(RoleEnum.COMPANY)) {
          return of(false);
        }
        return this.companyPagesService.getCompaniesDetailsSubject().pipe(
          filter((companies): companies is UserCompanyDetails[] => companies !== null),
          take(1),
          map(() => {
            if (this.companyPagesService.getSelectedCompany()) {
              return true;
            }
            this.router.navigate(['/company', 'switch']);
            return false;
          })
        );
      })
    );
  }
}

export const CompanyPagesGuard: CanActivateFn = () => {
  return inject(CompanyPagesPermissionsService).canActivate();
};
